// extracted by mini-css-extract-plugin
module.exports = {"leftNavigation":"CarouselLeft_leftNavigation__21y1p"};